import type {CountryCode} from 'libphonenumber-js/max';
import {isPossiblePhoneNumber} from 'libphonenumber-js/max';


const defaultCountry = 'US';

export const validatePhone = (
  number?: string | null,
  countryCode: CountryCode = defaultCountry,
): boolean => {
  if (!number || number.trim() === '') {
    return false;
  }

  return isPossiblePhoneNumber(number, countryCode);
};
